module.exports = __webpack_public_path__ + "img/Coulson_01.33ed2463.png";